import { makeStyles } from '@material-ui/core/styles';

export const useStylesTooltip = makeStyles((theme) => ({
    customTooltip: {
        backgroundColor: theme.palette.common.black,
        borderRadius: '10px',
    },
    customArrow: {
        color: theme.palette.common.black,
    },
}));
